import "./styles.css";
import "./panel-styles.css";
import { v4 } from "uuid";
import Info from "./info";
import "../../utils/extenso";
import { IPainel } from "../login";
import { api } from "../../services/api";
import { useState, useEffect } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import playAudio from "../../utils/play-audio";
import { Box, Modal, Typography } from "@mui/material";
import { IMessageEvent, w3cwebsocket as W3CWebSocket } from "websocket";
import Calls from "../../components/calls";
import useWeather from "../../hooks/useWeather";
import YouTube from "react-youtube";
import { LuDoorOpen, LuWind } from "react-icons/lu";
import { IoMdRainy } from "react-icons/io";
import { BsMoisture } from "react-icons/bs";
import { RiMapPin2Fill } from "react-icons/ri";

export interface ICall {
  name: string;
  local: string;
  password: string;
}

function checkSpecialCall(password: string): {
  output: string[];
  outPassword: any;
} {
  let output: string[] = ["Toque"];
  let outPassword: any = password;
  if (password[0] === "C" || password[0] === "P") {
    output.push({ C: "complementares", P: "Preferencial" }[password[0]]);
    outPassword = password.substring(1, outPassword.length);
  }
  return { output, outPassword };
}

function getPassword(password: string): { output: string[] } {
  let { output, outPassword } = checkSpecialCall(password);
  output = [...output, ...outPassword.extenso().split(" ")];
  return { output };
}

function capitalize(text: string): string {
  return text.charAt(0).toUpperCase() + text.slice(1);
}

let index = 1;

export default function Home() {
  const [CC, setCC] = useState<any[]>([]);
  const [open, setOpen] = useState(false);
  const [call, setCall] = useState<any>(null);
  const [geoLocation, setGeoLocation] = useState({
    latitude: null,
    longitude: null,
  });
  const [calls, setCalls] = useState<any[]>([]);
  const [haveBacked, setHaveBacked] = useState<boolean>();
  const [wsClient, setWsClient] = useState<W3CWebSocket>(null);
  const [isExecuting, setIsExecuting] = useState<boolean>(false);
  const [panelInfo, setPanelInfo] = useState<IPainel | null>(null);
  const [isPermittedAudio, setIsPermittedAudio] = useState<boolean>(false);
  const [now, setNow] = useState(new Date());
  const [callId, setCallId] = useState(v4());

  const navigate = useNavigate();
  const location: any = useLocation();

  const usaPlaylist = panelInfo?.PAIUSAPLAYLIST == 1;
  const usaClima = panelInfo?.PAIUSACLIMA == 1;
  const { current: weatherCurrent, forecast: weatherForecast } = useWeather(usaClima);

  useEffect(() => {
    const intervalId = setInterval(() => setNow(new Date()), 20000);
    return () => clearInterval(intervalId);
  }, []);

  useEffect(() => {
    if (!location.state?.haveBacked) {
      navigate("/", { replace: true, state: null });
    }
    window.history.pushState(null, null, document.URL);
    window.addEventListener("popstate", function (event) {
      event.preventDefault();
      setHaveBacked(true);
    });
  }, []);
  const handleClose = () => setOpen(false);

  useEffect(() => {
    const permittedAudio = `${localStorage.getItem("@App:permittedAudio")}`;
    permittedAudio != "null"
      ? setIsPermittedAudio(true)
      : setIsPermittedAudio(false);

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        function (position) {
          // User has permitted geolocation, position data is available
          var latitude = position.coords.latitude;
          var longitude = position.coords.longitude;
          setGeoLocation({
            latitude,
            longitude,
          });
        },
        function (error) {
          // User denied geolocation or an error occurred
          switch (error.code) {
            case error.PERMISSION_DENIED:
              setGeoLocation({
                latitude: null,
                longitude: null,
              });
              break;
            case error.POSITION_UNAVAILABLE:
              setGeoLocation({
                latitude: null,
                longitude: null,
              });
              break;
            case error.TIMEOUT:
              setGeoLocation({
                latitude: null,
                longitude: null,
              });
              break;
          }
        }
      );
    } else {
      setGeoLocation({
        latitude: null,
        longitude: null,
      });
    }
  }, []);

  const refreshToken = async () => {
    const req = await api();
    const response = await req.post(
      "/auth/login/refresh",
      {},
      {
        headers: {
          Authorization: localStorage.getItem("@App:Token_Painel"),
        },
      }
    );
    if (response.status === 200 && response.data.token) {
      localStorage.setItem("@App:Token_Painel", response.data.token);
    }
  };

  function connect(onmessage2: {
    ({ data }: { data: string }): Promise<void>;
    (message: IMessageEvent): void;
  }) {
    const ENDPOINT = "wss://apipainel.prosesmt.com.br/ws";
    const authorization = `${localStorage.getItem("@App:Token_Painel")}`;
    const client = new W3CWebSocket(
      `${ENDPOINT}?authorization=${authorization}`
    );
    setWsClient(client);

    client.onclose = async () => {
      setTimeout(() => connect(onmessage2), 500);
    };

    client.onerror = async () => {
      await refreshToken();
      setTimeout(() => connect(onmessage2), 500);
    };

    client.onmessage = onmessage2;
  }

  const onmessage = async ({ data }: { data: string }) => {
    try {
      const jsonData = JSON.parse(data);
      if (
        typeof jsonData.SENHA === "string" &&
        jsonData.SENHA.replace(/[0-9]/g, "").length <= 1
      ) {
        let { output } = getPassword(jsonData.SENHA);
        const call = {
          local: jsonData.LOCAL,
          password: jsonData.SENHA,
          name: jsonData.FUNNOME,
        };
        setCC((oldCC) => [...oldCC, { id: index, output, call }]);
        index += 1;
      }
    } catch (err) {
      try {
        const req = await api();
        const response = await req.post(
          "/auth/login/refresh",
          {},
          {
            headers: {
              Authorization: localStorage.getItem("@App:Token_Painel"),
            },
          }
        );
        if (response.status === 200 && response.data.token) {
          localStorage.setItem("@App:Token_Painel", response.data.token);
        }
      } catch (err) {}
    }
  };

  useEffect(() => {
    const panel = JSON.parse(localStorage.getItem("@App:Panel")) as IPainel;
    setPanelInfo(panel);
    const minhaFuncao = () => {
      if (wsClient) {
        if (wsClient?.readyState === wsClient?.OPEN) {
          return;
        } else {
          connect(onmessage);
        }
      }
    };
    connect(onmessage);
    setInterval(minhaFuncao, 1000);
  }, []);

  useEffect(() => {
    if (CC.length > 0) {
      if (isExecuting) {
        return;
      }
      setCall(CC[0]);
      setCallId(v4());
      playAudio(CC[0], setIsExecuting, setCalls);
      setCC(() => {
        setCall(null);
        return [];
      });
    }
  }, [CC, isExecuting, call]);

  useEffect(() => {
    let wakeLock = null;

    const requestWakeLock = async () => {
      if ("wakeLock" in navigator) {
        try {
          if ((navigator as any)?.wakeLock) {
            wakeLock = await (navigator as any)?.wakeLock?.request("screen");
            document.addEventListener("visibilitychange", async () => {
              if (wakeLock !== null && document.visibilityState === "visible") {
                wakeLock = await (navigator as any)?.wakeLock?.request(
                  "screen"
                );
              }
            });
          }
        } catch (err) {
          console.error("Falha ao ativar o Wake Lock:", err);
        }
      } else {
        console.log(
          "Screen Wake Lock API não está disponível neste navegador."
        );
      }
    };

    requestWakeLock();
  }, [navigator]);

  const clickDiv = () => {
    const div = document.getElementById("clickMeDiv");
    div?.click();
  };

  useEffect(() => {
    const intervalId = setInterval(clickDiv, 2000);

    return () => clearInterval(intervalId);
  }, []);

  const timeStr = now.toLocaleTimeString("pt-BR", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });
  const weekdayStr = capitalize(now.toLocaleDateString("pt-BR", { weekday: "long" }));
  const dayStr = now.toLocaleDateString("pt-BR", { day: "2-digit" });
  const monthStr = capitalize(now.toLocaleDateString("pt-BR", { month: "long" }));
  const dateStr = `${weekdayStr}, ${dayStr} de ${monthStr}`;

  const playlistOpts = {
    width: "100%",
    height: "100%",
    playerVars: {
      listType: "playlist",
      list: panelInfo?.PAILINKPLAYLIST,
      autoplay: 1,
      controls: 1,
      rel: 0,
      showinfo: 0,
    },
  };

  return (
    <div className="painel-page">
      <button
        id="clickMeDiv"
        style={{
          position: "absolute",
          top: "-20px",
          width: "1px",
          height: "1px",
        }}
        onClick={() => {
          console.log("clicou");
        }}
      />
      {isPermittedAudio ? (
        <>
          <header className={`painel-header ${usaPlaylist ? "painel-header--video" : ""}`}>
            <div className="painel-time-block">
              <span className="painel-time">{timeStr}</span>
              <span className="painel-date">{dateStr}</span>
            </div>

            {usaPlaylist && usaClima ? (
              <>
                <div className="painel-header-divider" />
                {weatherCurrent && (
                  <div className="painel-weather-current">
                    <img
                      className="painel-weather-icon"
                      src={`/assets/icons-wheather/${weatherCurrent.icon}.png`}
                      alt=""
                    />
                    <div className="painel-weather-current-info">
                      <div className="painel-location">
                        <RiMapPin2Fill size={16} />
                        {panelInfo?.PAICIDADE}, {panelInfo?.PAIESTADO}
                      </div>
                      <span className="painel-temp">
                        {Math.round(weatherCurrent.temp)}°C
                      </span>
                    </div>
                  </div>
                )}

                {weatherCurrent && <div className="painel-header-divider" />}

                {weatherCurrent && (
                  <div className="painel-weather-stats">
                    <div className="painel-weather-stat">
                      <LuWind size={24} />
                      <div className="painel-weather-stat-text">
                        <span className="painel-weather-stat-label">Vento</span>
                        <span className="painel-weather-stat-value">
                          {Math.round(weatherCurrent.windspeed)} km/h
                        </span>
                      </div>
                    </div>
                    <div className="painel-weather-stat">
                      <BsMoisture size={24} />
                      <div className="painel-weather-stat-text">
                        <span className="painel-weather-stat-label">Umidade</span>
                        <span className="painel-weather-stat-value">
                          {weatherCurrent.humidity}%
                        </span>
                      </div>
                    </div>
                    <div className="painel-weather-stat">
                      <IoMdRainy size={24} />
                      <div className="painel-weather-stat-text">
                        <span className="painel-weather-stat-label">Chuva</span>
                        <span className="painel-weather-stat-value">
                          {weatherCurrent.precipprob}%
                        </span>
                      </div>
                    </div>
                  </div>
                )}

                {weatherForecast.length > 0 && (
                  <div className="painel-header-divider" />
                )}

                {weatherForecast.length > 0 && (
                  <div className="painel-weather-forecast">
                    {weatherForecast.slice(0, 3).map((day) => (
                      <div className="painel-forecast-day" key={day.dayFull}>
                        <span className="painel-forecast-day-label">
                          <span className="painel-forecast-day-label-full">
                            {day.dayFull}
                          </span>
                          <span className="painel-forecast-day-label-short">
                            {day.dayShort}
                          </span>
                        </span>
                        <img src={`/assets/icons-wheather/${day.icon}.png`} alt="" />
                        <div className="painel-forecast-day-temps">
                          <span>{day.tempmax}°</span>
                          <span className="painel-forecast-day-min">
                            {day.tempmin}°
                          </span>
                        </div>
                      </div>
                    ))}
                  </div>
                )}

                <div className="painel-header-divider" />
                <div className="painel-weather-video painel-weather-video--third">
                  <YouTube
                    style={{ width: "100%", height: "100%" }}
                    opts={playlistOpts}
                  />
                </div>
              </>
            ) : usaPlaylist ? (
              <>
                <div className="painel-header-divider" />
                <div className="painel-weather-video">
                  <YouTube
                    style={{ width: "100%", height: "100%" }}
                    opts={playlistOpts}
                  />
                </div>
              </>
            ) : usaClima && weatherCurrent ? (
              <>
                <div className="painel-header-divider" />

                <div className="painel-weather-current">
                  <img
                    className="painel-weather-icon"
                    src={`/assets/icons-wheather/${weatherCurrent.icon}.png`}
                    alt=""
                  />
                  <div className="painel-weather-current-info">
                    <div className="painel-location">
                      <RiMapPin2Fill size={16} />
                      {panelInfo?.PAICIDADE}, {panelInfo?.PAIESTADO}
                    </div>
                    <span className="painel-temp">
                      {Math.round(weatherCurrent.temp)}°C
                    </span>
                  </div>
                </div>

                <div className="painel-header-divider" />

                <div className="painel-weather-stats">
                  <div className="painel-weather-stat">
                    <LuWind size={24} />
                    <div className="painel-weather-stat-text">
                      <span className="painel-weather-stat-label">Vento</span>
                      <span className="painel-weather-stat-value">
                        {Math.round(weatherCurrent.windspeed)} km/h
                      </span>
                    </div>
                  </div>
                  <div className="painel-weather-stat">
                    <BsMoisture size={24} />
                    <div className="painel-weather-stat-text">
                      <span className="painel-weather-stat-label">Umidade</span>
                      <span className="painel-weather-stat-value">
                        {weatherCurrent.humidity}%
                      </span>
                    </div>
                  </div>
                  <div className="painel-weather-stat">
                    <IoMdRainy size={24} />
                    <div className="painel-weather-stat-text">
                      <span className="painel-weather-stat-label">Chuva</span>
                      <span className="painel-weather-stat-value">
                        {weatherCurrent.precipprob}%
                      </span>
                    </div>
                  </div>
                </div>

                <div className="painel-weather-forecast">
                  {weatherForecast.map((day) => (
                    <div className="painel-forecast-day" key={day.dayFull}>
                      <span className="painel-forecast-day-label">
                        <span className="painel-forecast-day-label-full">
                          {day.dayFull}
                        </span>
                        <span className="painel-forecast-day-label-short">
                          {day.dayShort}
                        </span>
                      </span>
                      <img src={`/assets/icons-wheather/${day.icon}.png`} alt="" />
                      <div className="painel-forecast-day-temps">
                        <span>{day.tempmax}°</span>
                        <span className="painel-forecast-day-min">
                          {day.tempmin}°
                        </span>
                      </div>
                    </div>
                  ))}
                </div>
              </>
            ) : null}
          </header>

          <main className="painel-main">
            <Info id={callId} call={calls.length > 0 ? calls[0] : ({} as ICall)} />
            <Calls calls={calls} />
          </main>
        </>
      ) : (
        <div
          style={{
            width: "100%",
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <button
            style={{
              width: "50%",
              height: "10%",
              fontSize: "2rem",
              fontWeight: "bold",
            }}
            className="btn btn-success btn-block"
            onClick={() => {
              setIsPermittedAudio(true);
              localStorage.setItem("@App:permittedAudio", "true");
            }}
          >
            Permitir a reprodução de aúdio e localização
          </button>
        </div>
      )}
      <Modal
        open={isExecuting}
        style={{
          height: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography
            align="center"
            color={"rgba(255, 255, 255, 0.7)"}
            fontWeight={"900"}
            sx={{ fontSize: "clamp(1.2rem, 1.8rem, 2rem)", letterSpacing: "8px" }}
          >
            SENHA
          </Typography>
          <Typography
            variant="h1"
            component="h1"
            align="center"
            color={"white"}
            fontWeight={"600"}
            id="modal-modal-title"
            className="texto-piscante2"
            sx={{ fontSize: "clamp(6rem, 8rem, 9rem)" }}
          >
            {calls[0]?.password}
          </Typography>
          <Box
            sx={{
              mt: 2,
              gap: "14px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <LuDoorOpen size={38} color="rgba(255, 255, 255, 0.85)" />
            <Typography
              align="center"
              component="h2"
              sx={{ fontSize: "clamp(2rem, 3rem, 3.6rem)" }}
              color={"rgba(255, 255, 255, 0.85)"}
              fontWeight={"700"}
              id="modal-modal-description"
            >
              {calls[0]?.local}
            </Typography>
          </Box>
          <Typography
            variant="h2"
            align="center"
            component="h2"
            sx={{ mt: 2, fontSize: "clamp(3rem, 5rem, 6rem)" }}
            color={"white"}
            fontWeight={"600"}
            className="texto-piscante2"
          >
            {calls[0]?.name}
          </Typography>
        </Box>
      </Modal>
      <Modal
        open={haveBacked}
        style={{
          height: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
        aria-labelledby="modal-modal-title"
        onClose={() => setHaveBacked(false)}
        aria-describedby="modal-modal-description"
      >
        <Box sx={styleHaveBacked}>
          <button
            type="submit"
            style={{
              width: "50%",
              marginBottom: "20px",
            }}
            onClick={() => {
              // window.location.reload()
              navigate("/", { replace: true, state: { haveBacked: true } });
            }}
            className="btn btn-success btn-block btn-form"
          >
            Reiniciar
          </button>
          <button
            style={{
              width: "50%",
              marginBottom: "20px",
            }}
            onClick={() => {
              localStorage.clear();
              window.location.reload();
              Navigate({ to: "/", replace: true });
            }}
            className="btn btn-primary btn-block btn-form"
          >
            Sair
          </button>
        </Box>
      </Modal>
    </div>
  );
}

const style = {
  p: 4,
  width: "55%",
  maxHeight: "85vh",
  overflow: "hidden",
  boxShadow: 24,
  display: "flex",
  borderRadius: "28px",
  alignItems: "center",
  flexDirection: "column",
  justifyContent: "center",
  outline: "none !important",
  backgroundColor: "#14345c",
  position: "absolute" as "absolute",
};

const styleHaveBacked = {
  p: 4,
  gap: "20px",
  width: "30%",
  height: "8%",
  boxShadow: 24,
  display: "flex",
  borderRadius: "30px",
  alignItems: "center",
  outline: "none !important",
  backgroundColor: "white",
  justifyContent: "space-evenly",
  position: "absolute" as "absolute",
};
